export function setNow(now: number) {
  return {
    type: "SET_NOW",
    now,
  };
}
